<svg
  class="intervention-hero__graphic-svg"
  viewBox="0 0 596 537"
  role="img"
  aria-label="Abstract intervention hero graphic"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect class="shape shape--pink-pill" x="0" y="51" width="109" height="350" rx="54" />
  <circle class="shape shape--pink-circle" cx="54.5" cy="105" r="54.5" />

  <rect class="shape shape--blue-pill" x="209" y="79" width="279" height="100" rx="50" />
  <circle class="shape shape--blue-circle" cx="435" cy="129" r="53.5" />

  <rect class="shape shape--teal-pill" x="108" y="185" width="380" height="108" rx="50" />
  <circle class="shape shape--teal-circle" cx="162" cy="239" r="53.5" />

  <circle class="shape shape--blue-circle-dark" cx="162" cy="347" r="53.5" />

  <rect class="shape shape--purple-pill-bottom" x="317" y="293" width="279" height="108" rx="54" />
  <circle class="shape shape--purple-circle-bottom" cx="542.5" cy="347" r="53.5" />

  <rect class="shape shape--gold-pill" x="488" y="0" width="108" height="293" rx="54" />
  <circle class="shape shape--gold-circle" cx="542.5" cy="239" r="53.5" />

  <circle class="shape shape--purple-circle-top" cx="435" cy="25" r="54.5" />
  <circle class="shape shape--blue-circle-bottom-right" cx="542.5" cy="453" r="53.5" />
</svg>

<style>
  .shape {
    transition: opacity 0.3s ease;
  }

  .shape--pink-pill {
    fill: rgba(220, 61, 98, 0.82);
  }

  .shape--pink-circle {
    fill: rgba(220, 61, 98, 0.82);
  }

  .shape--blue-pill {
    fill: rgba(35, 134, 200, 0.58);
  }

  .shape--blue-circle {
    fill: rgba(35, 134, 200, 0.78);
  }

  .shape--teal-pill {
    fill: rgba(98, 192, 188, 0.72);
  }

  .shape--teal-circle {
    fill: rgba(98, 192, 188, 0.82);
  }

  .shape--blue-circle-dark {
    fill: rgba(35, 134, 200, 0.88);
  }

  .shape--purple-pill-bottom {
    fill: rgba(122, 74, 157, 0.58);
  }

  .shape--purple-circle-bottom {
    fill: rgba(122, 74, 157, 0.74);
  }

  .shape--gold-pill {
    fill: rgba(247, 165, 32, 0.55);
  }

  .shape--gold-circle {
    fill: rgba(247, 165, 32, 0.82);
  }

  .shape--purple-circle-top {
    fill: rgba(122, 74, 157, 0.72);
  }

  .shape--blue-circle-bottom-right {
    fill: rgba(35, 134, 200, 0.62);
  }
</style>
